import React from 'react';
import {Navigate, Route} from 'react-router-dom';
import home from './home/routes';
import playground from './playground/routes';

export default [
  <Route
    key="/business/showcase/3d-viewer/"
    path="business/showcase/3d-viewer/"
    element={<Navigate to="../business/showcase/3d-viewer/home" replace />}
  />,
  home,
  playground,
];
